import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmFormTitleComponent } from './arm-form-title.component';



@NgModule({
    declarations: [ArmFormTitleComponent],
    exports: [
        ArmFormTitleComponent
    ],
    imports: [
        CommonModule
    ]
})
export class ArmFormTitleModule { }
